<!--
    BD Plan-Break Decision Dialog - Wave 2.3
    p-dialog mit 4 Entscheidungs-Optionen für den gebrochenen Zahlungsplan.
    @ticket TM-1000001782
-->
@if (initialized) {
    <p-dialog
        [(visible)]="visible"
        [modal]="true"
        [closable]="true"
        [closeOnEscape]="true"
        [dismissableMask]="false"
        [style]="{width: '38rem'}"
        header="Reaktion auf Plan-Bruch"
        (visibleChange)="onVisibleChange($event)">

        <div class="flex flex-column gap-3 p-2">

            <!-- Mahnungs-Info -->
            <div class="surface-card border-round p-3 flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-user text-primary"></i>
                    <span class="font-semibold">Kunde:</span>
                    <span>{{ customerName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-file-lines text-primary"></i>
                    <span class="font-semibold">Mahn-Typ:</span>
                    <span>{{ dunningTypeName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-layer-group text-primary"></i>
                    <span class="font-semibold">Aktive Stufe:</span>
                    <span>{{ activeLevelLabel }}</span>
                </div>
            </div>

            <!-- Hinweis -->
            <p-message
                severity="warn"
                text="Der Zahlungsplan wurde gebrochen. Wie soll fortgesetzt werden?"
                styleClass="w-full">
            </p-message>

            <!-- Optionen -->
            <div class="flex flex-column gap-2">
                @for (option of options; track option.value) {
                    <button
                        type="button"
                        class="p-3 border-1 border-round flex align-items-center gap-3 text-left cursor-pointer bd-option-button"
                        [class.bd-option-selected]="selectedOption === option.value"
                        [disabled]="submitting"
                        (click)="selectOption(option.value)">
                        <i class="text-xl" [ngClass]="option.icon"></i>
                        <span class="font-medium">{{ option.label }}</span>
                    </button>
                }
            </div>

            <!-- Kommentar -->
            <div class="flex flex-column gap-2">
                <label class="font-medium">Kommentar (optional)</label>
                <textarea
                    pTextarea
                    rows="3"
                    [(ngModel)]="comment"
                    placeholder="Zusätzlicher Kontext zur Entscheidung…"
                    class="w-full">
                </textarea>
            </div>

            <!-- Error -->
            @if (errorMessage) {
                <p-message
                    severity="error"
                    [text]="errorMessage"
                    styleClass="w-full">
                </p-message>
            }
        </div>

        <!-- Footer -->
        <ng-template #footer>
            <div class="flex justify-content-end gap-2 w-full">
                <p-button
                    label="Abbrechen"
                    severity="secondary"
                    [disabled]="submitting"
                    (onClick)="onCancel()">
                </p-button>
                <p-button
                    label="Bestätigen"
                    icon="fa-regular fa-check"
                    [loading]="submitting"
                    [disabled]="selectedOption === null"
                    (onClick)="confirm()">
                </p-button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Sub-Dialog: Pause auswählen -->
    @if (pauseDialogVisible && dunning) {
        <mvs-bd-pause-dialog
            [dunning]="dunning"
            [uiComponentConfig]="uiComponentConfig"
            (actionCompleted)="onPauseCompleted()"
            (actionCancelled)="onPauseCancelled()">
        </mvs-bd-pause-dialog>
    }
}
